import React from "react";
import { KatlasMark } from "./Reveal";

export default function SiteFooter() {
  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="wrap site-footer__inner">
        <div className="site-footer__brand">
          <KatlasMark size={28} />
          <div>
            <div className="site-footer__name">KATLAS</div>
            <div className="site-footer__tag">Authority Journey · A Cierge Labs Storybook</div>
          </div>
        </div>
        <nav className="site-footer__routes">
          <a href="https://www.katlastechnology.com/" data-testid="footer-route-technology">KATLAS Technology</a>
          <a href="https://platform.katlastechnology.com/" data-testid="footer-route-platform">KATLAS Platform</a>
          <a href="https://labs.katlastechnology.com/" data-testid="footer-route-labs">Cierge Labs</a>
        </nav>
      </div>
      <div className="wrap site-footer__legal">
        Synthetic demonstration using fictional organisations and evidence. Illustrative governed
        outcomes only — not live KATLAS-signed receipts.
      </div>
    </footer>
  );
}
